var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"share-wechat-btn"},[_vm._v("\n    分享：\n    "),_c('i',{staticClass:"u-wechat-icon"}),_c('span',{staticClass:"wechat-qr-code"},[_c('em'),_c('qrcode-vue',{attrs:{"value":_vm.localHref,"size":116,"level":"H"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }